import React from "react"
import VerificarAntecedentes from "./VerificarAntecedentes"

export default function CheckProfile() {
  return <VerificarAntecedentes />
}
